import { trpc } from "@/lib/trpc";

export const useConnectorsQuery = () => trpc.agentTypes.getAll.useQuery();
